// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"0fa03b64","399":"a8698298","573":"e24b07da","588":"978baf83","683":"a0fb855b","784":"b3616918","787":"bed44058"}[chunkId] + ".chunk.js";
};